export function isQueryEmpty(query) {
    return !query?.AND?.some(group => group.OR?.length > 0);
}
